// @core/api/endpoints/secret/seal.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  SealRequest,
} from '../../../types/secret';

const BASE_PATH = '/secret';

/**
 * Seal the service
 * Seals the Secret service, requiring unseal keys to resume operations. All in-flight operations will complete, but no new operations will be accepted. Requires sudo capability.
 */
export async function Seal(
  data: SealRequest,
  options?: RequestOptions
): Promise<Response> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/sys/seal`;
  const requestOptions = options;
  return client.post<Response>(requestPath, data, requestOptions);
}
